<template>
  <v-row justify="center">
    <v-col
      sm="3"
      md="4"
    >
      <v-card
        elevation="20"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle /> <br>
            <v-list-item-subtitle align="center">
              <strong> <h2> Marketing Executive</h2> </strong>
            </v-list-item-subtitle> <hr>
            <v-list-item-subtitle align="center">
              <h4>Immediate Opening </h4>
            </v-list-item-subtitle>

            <v-list-item-subtitle /> <br>
            <v-list-item-subtitle>
              <b>
                The Job: </b>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Able to perform full sets of accounts with minimal supervision.<br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Knowledge of double-entry.<br>
            </v-list-item-subtitle> <br>
            <hr> <br>

            <v-list-item-subtitle>
              <b>Requirements:</b>
            </v-list-item-subtitle>

            <v-list-item-subtitle>
              - Woodlands Area - walking distance from MRT <br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Monday to Friday - 9am to 6pm<br> <br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Singaporean and PR<br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Atleast 2 years accounting experience<br><br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Knowledge in Quickbooks, MYOB or Xero<br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Responsibilities - Bookkeeping, AP, AR and reporting<br> <br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              - Able to work independently, as a team and multi-task<br>
            </v-list-item-subtitle>

            <v-list-item-subtitle /> <br>
            <v-btn
              rounded
              outlined
              min-width="168"
              align="center"
              @click="dialog = !dialog"
            >
              Apply Here
            </v-btn>
            <v-list-item-subtitle />
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>

    <v-col
      sm="3"
      md="4"
    >
      <v-card
        elevation="20"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle /> <br>
            <v-list-item-subtitle align="center">
              <strong> <h2> Tax Assistant</h2> </strong>
            </v-list-item-subtitle> <hr>
            <v-list-item-subtitle align="center">
              <h4>Immediate Opening </h4>
            </v-list-item-subtitle>

            <v-list-item-subtitle /> <br>
            <v-list-item-subtitle>
              <b>
                The Job: </b>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – The potential candidate will primarily be responsible for Corporate Income Tax compliance in Singapore.<br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – In addition, he/she may be required to assist in handling matters relating to Singapore Individual Income Tax, and resolving tax controversy issues with the Tax Authorities.<br>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – The potential candidate is expected to keep abreast of changes in the relevant tax legislation and practice guidelines.
            </v-list-item-subtitle>
            <br>

            <hr> <br>
            <v-list-item-subtitle>
              <b>Requirements:</b>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Diploma in Accountancy with at least 2 to 4 years of relevant experience.
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Commercial experience would be an advantage.
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Technical skills and knowledge in accounting and taxation.
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              – Ability to communicate with ease and confidence.
            </v-list-item-subtitle>

            <v-list-item-subtitle /> <br>
            <v-btn
              rounded
              outlined
              min-width="168"
              align="center"
              @click="dialog = !dialog"
            >
              Apply Here
            </v-btn>
            <v-list-item-subtitle />
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data: () => ({
      files: [],
    }),
  }
</script>
